/* The app owns its feed, media and account link. This wrapper only handles empty/loading states. */
if (!customElements.get('sd-instafeed')) {
  customElements.define('sd-instafeed', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const media = [...this.querySelectorAll('#insta-feed img, #insta-feed video, [id^="insta-feed-"] img, [id^="insta-feed-"] video')];
        // Instafeed uses IntersectionObserver to load data-instafeed-src. Reveal
        // real media references first so the collapsed wrapper cannot deadlock it.
        const ready = media.some(item => !!(
          item.getAttribute('data-instafeed-src') || item.getAttribute('src') ||
          item.getAttribute('poster') || item.querySelector('source[src]')
        ));
        this.dataset.ready = String(ready);
      };
      this.addEventListener('load', this.update, true);
      this.addEventListener('error', this.update, true);
      this.addEventListener('loadeddata', this.update, true);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'poster', 'data-instafeed-src'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('load', this.update, true);
      this.removeEventListener('error', this.update, true);
      this.removeEventListener('loadeddata', this.update, true);
    }
  });
}
